<template>
    <div class="page">
        <p class="tit">请输入手机号</p>
        <div class="inp mt-25" data-flex="cross:center">
            <van-field class="f-fs12 f-fs14" v-model="formData.mobileNumber" type="tel" placeholder="请输入手机号" />
            <p @click="sendMCode">{{ btn1Text }}</p>
        </div>
        <p class="tit">请输入验证码</p>
        <div class="inp mt-25" data-flex="cross:center">
            <van-field class="f-fs12 f-fs14" v-model="formData.mcode" type="tel" placeholder="请输入验证码" />
        </div>
        <div class="btn">
            <van-button type="primary" @click="bindMobile">绑定手机</van-button>
        </div>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, NumberKeyboard, Field } from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
    mixins: [mix1],
    components: {
        MgPopup, Button, NumberKeyboard,
        [Field.name]: Field,
        [Button.name]: Button,
    },
    data() {
        return {
            isCountdowning: false,
            btn1Text: '获取验证码',
            formData: {
                mcode: '',
                mobileNumber: '',
            },
            page: 1
        }
    },
    methods: {
        async sendMCode() {
            if (this.isCountdowning) {
                return
            }

            const mobile = this.formData.mobileNumber

            if (!mobile) {
                uiAlert('请填写手机号码')
                return
            }

            uiShowLoading()
            await delayAsync(500)
            let apiResult = null

            try {
                apiResult = await this.apiPost('fans.sendcode', { mobileNumber: mobile })
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.isEmpty(apiResult)) {
                return
            }

            let secs = 60
            this.btn1Text = secs
            this.isCountdowning = true

            const t1 = setInterval(() => {
                if (secs < 1) {
                    clearInterval(t1)
                    this.btn1Text = '获取验证码'
                    this.isCountdowning = false
                    return
                }

                secs--
                this.btn1Text = secs
            }, 1000)
        },
        async bindMobile() {
            let formData = this.formData
            const promise = this.apiPost('bindMobile', formData)

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }
            console.log(apiResult)

            if (this.hasException(apiResult)) {
                return
            }

            uiAlert('绑定成功', () => this.$router.go(-1))
            // this.profile = apiResult.obj
        },

    },
    mounted() {

    },
    created() {
        let query = this.$route.query
    }
}
</script>

<style lang="less" scoped>
.page {
    height: calc(100vh - 20px);
    padding: 65px 85px;
    box-sizing: border-box;
    background: #fff;
    margin-top: 20px;

    .tit {
        font-size: 14px;
    }

    .inp {
        border: solid 1px #BFBFBF;
        width: 100%;
        margin: 0 auto;
        border-radius: 10px;
        margin-bottom: 40px;

        .van-cell {
            padding: 20px;
        }

        .van-cell::after {
            border: none;
        }

        p {
            font-size: 12px;
            color: #609FFA;
            width: 170px;
            padding-right: 20px;
            text-align: right;
        }
    }


    .btn {
        text-align: center;
        margin-top: 65px;

        button {

            width: 360px;
            height: 80px;
            border-radius: 200px;
            background: #205CFF;
            border-color: #205CFF;
            margin: 0 auto;
        }
    }

}
</style>